export const getPortalName = (pathname: string) => {
  if (pathname.startsWith('/cms-p10n')) {
    return '/cms-p10n'
  }
  if (pathname.startsWith('/cms')) {
    return '/cms'
  }
  if (pathname.startsWith('/pcm-p10n')) {
    return '/pcm-p10n'
  }
  if (pathname.startsWith('/pcm')) {
    return '/pcm'
  }
  if (pathname.startsWith('/csm')) {
    return '/csm'
  }
  if (pathname.startsWith('/scm')) {
    return '/scm'
  }
  if (pathname.startsWith('/sgm')) {
    return '/sgm'
  }
  if (pathname.startsWith('/admin')) {
    return '/admin'
  }

  if (pathname.startsWith('/stream')) {
    return '/stream'
  }
  if (pathname.startsWith('/user')) {
    return '/user'
  }

  if (pathname.startsWith('/wallet')) {
    return '/wallet'
  }
  if (pathname.startsWith('/game')) {
    return '/game'
  }

  return ''
}
